import { TweenMax } from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
import "imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap";

var controller = new ScrollMagic.Controller();

if (document.querySelector(".js-hub-text-slider-start-01")) {
  var iconTween1 = TweenMax.to(
    $(".js-hub-text-slider-start-01").find(".grand-top-coworking__icon"),
    8,
    {
      x: 50 + "%",
      force3D: true,
      ease: Quint.easeOut,
    }
  );

  let scene = new ScrollMagic.Scene({
    triggerElement: ".js-hub-text-slider-start-01",
    triggerHook: "onLeave",
    reverse: true,
    duration: document.querySelector(".js-hub-text-slider-start-01")
      .clientHeight,
    offset: -200,
  })
    .setTween(iconTween1)
    // .addIndicators()
    .addTo(controller);

  var iconTween2 = TweenMax.to(
    $(".js-hub-text-slider-start-02").find(".grand-top-coworking__icon"),
    8,
    {
      x: -50 + "%",
      force3D: true,
      ease: Quint.easeOut,
    }
  );

  let scene2 = new ScrollMagic.Scene({
    triggerElement: ".js-hub-text-slider-start-02",
    triggerHook: "onLeave",
    reverse: true,
    duration: document.querySelector(".js-hub-text-slider-start-02")
      .clientHeight,
    offset: -200,
  })
    .setTween(iconTween2)
    // .addIndicators()
    .addTo(controller);

  var iconTween3 = TweenMax.to(
    $(".js-hub-text-slider-start-03").find(".grand-top-coworking__icon"),
    8,
    {
      x: 50 + "%",
      force3D: true,
      ease: Quint.easeOut,
    }
  );

  let scene3 = new ScrollMagic.Scene({
    triggerElement: ".js-hub-text-slider-start-03",
    triggerHook: "onLeave",
    reverse: true,
    duration: document.querySelector(".js-hub-text-slider-start-03")
      .clientHeight,
    offset: -200,
  })
    .setTween(iconTween3)
    // .addIndicators()
    .addTo(controller);
}
